import {useEffect, useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import EnterCodeAuthenticatorComponent from "../components/EnterCodeAuthenticatorComponent";
import {useTranslation} from "i18nano";
import useFormattingTranslation from "../hooks/useFormattingTranslations";
import {ApiService} from "../api/ApiService";
import {useUserStore} from "../stores/userStore";
import {useAuthStore} from "../stores/authStore";
import {useNotification} from "../stores/notificationStore";
import WithLogoAndSelectLanguageWrapper from "../components/WithLogoAndSelectLanguageWrapper";
import StackCard from "../components/StackCard";

const TwoFactorAuthentication = () => {
    const authStore = useAuthStore();
    const userStore = useUserStore();
    const notification = useNotification();
    const navigate = useNavigate();
    const t = useTranslation();
    const tf = useFormattingTranslation();

    const [loading, setLoading] = useState(false);

    const sendCode = async (code: any) => {
        setLoading(true)
        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.Login(authStore.login, authStore.password, code, 0);
        if (response.success) {
            userStore.login(response.data);
        } else {
            notification.open(response.errors[0], "error");
        }
        setLoading(false);
    }
    useEffect(() => {
        if (!authStore.login || !authStore.password) {
            navigate("/login")
        }
    }, [])

    return (
            <WithLogoAndSelectLanguageWrapper>
                <StackCard>
                    <EnterCodeAuthenticatorComponent
                            onClick={sendCode} loading={loading}
                            title={t("Two factor Authentication")}
                            description={tf("Your login is protected with an Authenticator")}
                    />
                    {authStore.response && authStore.response.data && authStore.response.data.availableTwoFactorProviders.includes(1) ?
                            <NavLink to={"/two-factor-authentication/phone"}
                                     style={{display: "block", width: "100%", textAlign: "center", marginTop: "10px"}}>
                                {t("Use phone number instead")}
                            </NavLink>
                            : null
                    }
                </StackCard>
            </WithLogoAndSelectLanguageWrapper>
    )
}

export default TwoFactorAuthentication;